import { render, staticRenderFns } from "./NaturalDateField.vue?vue&type=template&id=10a4e5e6"
import script from "./NaturalDateField.vue?vue&type=script&lang=js"
export * from "./NaturalDateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports